module.exports = __webpack_public_path__ + "static/media/RobotoCondensed-Regular.9c6aac5e.ttf";